module.exports = __webpack_public_path__ + "static/media/ParallelGateway.31b7e8cc.svg";